module.exports = "img/flags/JP.5702fe2.png";